import React, { useEffect, useState } from "react";
import { FeedAvatar, FeedAvatarImage } from "src/components/NoticeboardFeedUi";
import { getInitials, resolveProfilePictureUrl } from "../../feedUtils";

const NoticeboardFeedAvatar = ({ displayName, profilePictureUrl, size, fontSize }) => {
    const [imageFailed, setImageFailed] = useState(false);
    const resolvedProfilePictureUrl = resolveProfilePictureUrl(profilePictureUrl);
    const showImage = Boolean(resolvedProfilePictureUrl) && !imageFailed;

    useEffect(() => {
        setImageFailed(false);
    }, [resolvedProfilePictureUrl]);

    if (!showImage && !displayName) {
        return null;
    }

    return (
        <FeedAvatar
            $size={size}
            $fontSize={fontSize}
            aria-label={!showImage && displayName ? `${displayName} initials` : undefined}
            title={displayName || undefined}
        >
            {showImage ? (
                <FeedAvatarImage
                    key={resolvedProfilePictureUrl}
                    src={resolvedProfilePictureUrl}
                    alt={displayName ? `${displayName} profile` : "Profile"}
                    loading="eager"
                    decoding="async"
                    onError={() => setImageFailed(true)}
                />
            ) : getInitials(displayName)}
        </FeedAvatar>
    );
};

export default NoticeboardFeedAvatar;
